import React from "react";
import { DropdownButton } from "../Button";

import bloodCenterSiteQuery from "../../utils/queries/bloodCenterSiteQuery";
import { Loading } from "../Loader";
import icons from "../../constants/icons";
import { CardHeader } from "../Header";
import { connect } from "react-redux";
import language from "../../language";
import { Checkbox } from "../Input";

let copyData = [];

class CentersFilter extends React.Component {
  state = {
    isLoading: true,
    selectedCentersSites: [],
    data: [],
    page: 1,
    limit: 50,
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.categoryType !== this.props.categoryType) {
      await this.getData(true);
    }

    const getCenterIdsSignature = (centers = []) =>
      (centers || [])
        .map((el) => el?.value || el?._id || el)
        .filter(Boolean)
        .sort()
        .join(",");

    const prevCenterIds = getCenterIdsSignature(prevProps.selectedCenters);
    const nextCenterIds = getCenterIdsSignature(this.props.selectedCenters);

    if (prevCenterIds !== nextCenterIds) {
      await this.getData(true);
    }
  };

  getData = async (isLoading) => {
    try {
      const { defaultLanguage, filters, selectedCenters = [] } = this.props;
      const { page } = this.state;

      this.setState({ isLoading });

      const centersToUse =
        selectedCenters.length > 0
          ? selectedCenters
          : filters?.centers || [];

      const data = await bloodCenterSiteQuery(defaultLanguage, {
        page,
        limit: 10000,
        type: "dropdown",
        center: centersToUse?.map((el) => el.value),
      });

      const availableSiteIds = new Set((data || []).map((el) => el._id));
      const selectedCentersSites = (this.state.selectedCentersSites || []).filter(
        (el) => availableSiteIds.has(el.value),
      );

      this.setState({
        data: data,
        selectedCentersSites,
        isLoading: false,
      });

      // Propagate filtered center sites when selected centers change.
      if (
        this.props.handleApplyFilters &&
        selectedCentersSites.length !==
          (this.state.selectedCentersSites || []).length
      ) {
        this.props.handleApplyFilters(true, {
          centerSites: selectedCentersSites,
        });
      }

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onCheck = async (el) => {
    let { filters } = this.props;
    let { centerSites = [] } = filters;
    const selectedCentersSites = this.state.selectedCentersSites?.length
      ? this.state.selectedCentersSites
      : centerSites;

    const exists = selectedCentersSites.some((sEl) => sEl.value === el._id);
    const nextSelectedCenterSites = exists
      ? selectedCentersSites.filter((sEl) => sEl.value !== el._id)
      : [...selectedCentersSites, { value: el._id, label: el.name }];

    // if (this.props.filterName) {
    //   await this.props.dispatch(
    //     onAddFilter({
    //       [this.props.filterName]: selectedCentersSites,
    //     })
    //   );
    // } else {
    //   await this.props.dispatch(
    //     onAddFilter({
    //       centerSites:selectedCentersSites,
    //     })
    //   );
    // }

    this.setState({ selectedCentersSites: nextSelectedCenterSites });

    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, {
        centerSites: nextSelectedCenterSites,
      });
  };

  async handleSearch(e) {
    const searchValue = e?.target?.value;
    this.setState({ searchValue });

    const searchText = (searchValue || "").trim().toLowerCase();

    if (!searchText) {
      this.setState({ data: copyData.slice(0) });
      return;
    }

    let results = [];
    copyData.forEach((el) => {
      if (el.name.toLowerCase().indexOf(searchText) !== -1) {
        results.push(el);
      }
    });

    if (results.length > 0) {
      this.setState({ data: results });
      return;
    }

    // Fallback to remote search when local center-site list has no matches.
    try {
      const { defaultLanguage, selectedCenters = [], filters } = this.props;
      const centersToUse =
        selectedCenters.length > 0 ? selectedCenters : filters?.centers || [];

      const remoteData = await bloodCenterSiteQuery(defaultLanguage, {
        page: 1,
        limit: 10000,
        type: "dropdown",
        center: centersToUse?.map((el) => el.value),
        q: searchValue,
      });

      this.setState({ data: remoteData || [] });
    } catch (error) {
      this.setState({ data: [] });
    }
  }

  render() {
    const selectedCenterSites = this.state.selectedCentersSites || [];
    const selectedCenterSiteLabels = selectedCenterSites
      .map((el) => el?.label)
      .filter(Boolean);

    const centerSiteButtonText =
      selectedCenterSiteLabels.length > 0
        ? `${language[this.props.defaultLanguage].filter_center_site}: ${selectedCenterSiteLabels.join(", ")}`
        : language[this.props.defaultLanguage].filter_center_site;

    return (
      <DropdownButton
        leftIcon={icons.centerSite}
        text={centerSiteButtonText}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.props?.filters?.centerSite}
        clickOutside
        disabled={this.props.disabled}
      >
        <CardHeader
          title={language[this.props.defaultLanguage].filter_center_site}
          borderBottom
          closeButton
          isSearch
          searchValue={this.state.searchValue}
          handleSearch={(e) => this.handleSearch(e)}
        />
        <div className="dropdown-content">
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : (
            this.state?.data?.map((el, i) => {
              return (
                <Checkbox
                  label={el.name}
                  key={i}
                  onCheck={() => this.onCheck(el)}
                  checked={selectedCenterSites?.find(
                    (sEl) => sEl.value === el._id
                  )}
                />
              );
            })
          )}
        </div>
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(CentersFilter);
